

























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { LocationDetailsModule } from "@/store/modules/locationDetails";
import LocationGeneralDetailsEdit from "@/components/Locations/LocationGeneralDetailsEdit.vue";
import LocationBrandDetailsEdit from "@/components/Locations/LocationProfileDetailsEdit.vue";
import LocationHealthAndSafetyAssessmentEdit from "@/components/Locations/LocationHealthAndSafetyAssessmentEdit.vue";
import LocationAddressDetailsEdit from "@/components/Locations/LocationAddressDetailsEdit.vue";
import LocationAccountingDetailsEdit from '@/components/Locations/LocationAccountingDetailsEdit.vue';
import LocationExternalPayrollEdit from '@/components/Locations/LocationExternalPayrollEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: "CompanyDetails",
  components: { LocationGeneralDetailsEdit, LocationAccountingDetailsEdit, LocationExternalPayrollEdit, LocationAddressDetailsEdit, LocationBrandDetailsEdit, LocationHealthAndSafetyAssessmentEdit }//, AddressDetailsEdit },
})
export default class extends GiganautVue {
	
	get currentLocation() {
	return LocationDetailsModule.currentLocation;
	}

  get companyUrl() {
    return "/agency/companies/" + this.currentLocation.companyId;
  }

	departmentHeaders = [
		{ text: 'Name', value: 'name' },
		{ text: 'Arrival Instructions', value: 'arrivalInstructions' },
	]
    get currentLocationFullAddressLine () {
      return [LocationDetailsModule.currentLocation.buildingNameNumber,
              LocationDetailsModule.currentLocation.streetRoadBlock,
              LocationDetailsModule.currentLocation.locality,
              LocationDetailsModule.currentLocation.cityTown,
              LocationDetailsModule.currentLocation.stateProvinceRegion,
              LocationDetailsModule.currentLocation.postZipCode]
              .filter(Boolean).join(", ");
    }
}
